import styled from "styled-components";

import { NotificationTicketContainer } from "../NotificationTicket/styles";
import { NotificationTitleContainer } from "../NotificationTitle/styles";

export const NotificationTicketTextContentContainer = styled.div`
  padding: 1.125rem 1rem 1.5rem;

  border-radius: 4px;

  background: ${({ theme }) => `${theme.notification.title}1a`};

  margin: 12px 0;

  --mask-height-percentage: 49%;
  @media (max-width: 1366px) {
    --mask-height-percentage: 41%;
  }
  -webkit-mask: radial-gradient(
        circle 8px at left var(--mask-height-percentage),
        transparent 7px,
        black 8px
      )
      left / 50% no-repeat,
    radial-gradient(
        circle 8px at right var(--mask-height-percentage),
        transparent 7px,
        black 8px
      )
      right / 50% no-repeat;

  mask: radial-gradient(
        circle 8px at left var(--mask-height-percentage),
        transparent 7px,
        black 8px
      )
      left / 50% no-repeat,
    radial-gradient(
        circle 8px at right var(--mask-height-percentage),
        transparent 7px,
        black 8px
      )
      right / 50% no-repeat;

  & :has([data-element-has-multiple-lines="true"]) {
    --mask-height-percentage: 55%;
    @media (max-width: 1366px) {
      --mask-height-percentage: 47%;
    }
    -webkit-mask: radial-gradient(
          circle 8px at left var(--mask-height-percentage),
          transparent 7px,
          black 8px
        )
        left / 50% no-repeat,
      radial-gradient(
          circle 8px at right var(--mask-height-percentage),
          transparent 7px,
          black 8px
        )
        right / 50% no-repeat;

    mask: radial-gradient(
          circle 8px at left var(--mask-height-percentage),
          transparent 7px,
          black 8px
        )
        left / 50% no-repeat,
      radial-gradient(
          circle 8px at right var(--mask-height-percentage),
          transparent 7px,
          black 8px
        )
        right / 50% no-repeat;
  }

  & > ${NotificationTitleContainer} {
    font: 500 0.75rem/150% "Inter";
    letter-spacing: 0;
    vertical-align: middle;
  }

  ${NotificationTicketContainer} {
    font: 600 0.875rem/150% "Inter";
    letter-spacing: 0;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
